import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54396261"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/close-btn.svg",
    class: "close-popup-btn"
  })
], -1))
const _hoisted_4 = { class: "payment-details" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "heading" }
const _hoisted_7 = { class: "amount-container" }
const _hoisted_8 = { class: "total-amount" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "progress-container" }
const _hoisted_12 = { class: "payment-info" }
const _hoisted_13 = { class: "gap completed" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot-1" }, null, -1))
const _hoisted_15 = { class: "label-wrapper" }
const _hoisted_16 = { class: "label-1" }
const _hoisted_17 = { class: "app-format-currency" }
const _hoisted_18 = { class: "gap processing" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot-2" }, null, -1))
const _hoisted_20 = { class: "label-wrapper" }
const _hoisted_21 = { class: "label-2" }
const _hoisted_22 = { class: "app-format-currency" }
const _hoisted_23 = { class: "payment-info-item" }
const _hoisted_24 = { class: "payment-details-container" }
const _hoisted_25 = { class: "status-chevron" }
const _hoisted_26 = {
  key: 0,
  class: "status-button pending"
}
const _hoisted_27 = {
  key: 1,
  class: "status-button successful"
}
const _hoisted_28 = {
  key: 2,
  class: "status-button cancelled"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "payment-detail-item"
}
const _hoisted_32 = { class: "payment-detail-label" }
const _hoisted_33 = { class: "payment-detail-value" }
const _hoisted_34 = { class: "payment-detail-item" }
const _hoisted_35 = { class: "payment-detail-label" }
const _hoisted_36 = { class: "payment-detail-value" }
const _hoisted_37 = { class: "payment-detail-item" }
const _hoisted_38 = { class: "payment-detail-label" }
const _hoisted_39 = { class: "payment-detail-value" }
const _hoisted_40 = { class: "payment-detail-item" }
const _hoisted_41 = { class: "payment-detail-label" }
const _hoisted_42 = { class: "payment-detail-value" }
const _hoisted_43 = { class: "payment-detail-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "payment-detail-label" }, "ID:", -1))
const _hoisted_45 = { class: "payment-detail-value" }
const _hoisted_46 = {
  key: 1,
  class: "button-container"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  style: {"margin-left":"15px"}
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "dropdown" }
const _hoisted_51 = { class: "dropdown-content" }
const _hoisted_52 = { class: "img-item" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "title-item-container" }
const _hoisted_55 = { class: "title-item-1" }
const _hoisted_56 = { class: "title-item-2" }
const _hoisted_57 = { class: "title-item-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.payments" })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_i18n_t, { keypath: "myOrders.totalAmount" }),
              _createTextVNode(" : ")
            ]),
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_app_format_currency, {
                value: _ctx.orderPaymentDto?.order_total_amount_including_vat,
                currency: "EUR"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "progress-bar",
              style: _normalizeStyle({
                                width: _ctx.dot1Position,
                            })
            }, null, 4),
            _createElementVNode("div", {
              class: "overlay-progress-bar",
              style: _normalizeStyle({
                                width: _ctx.dot2Position,
                            })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.paidCompleted" }),
                  _createTextVNode(":")
                ]),
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_app_format_currency, {
                    value: _ctx.orderPaymentDto?.amount_paid_confirmed,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.paidProcessing" }),
                  _createTextVNode(":")
                ]),
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_app_format_currency, {
                    value: _ctx.orderPaymentDto.amount_paid_pending,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderPaymentDto?.payments, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "payment-item",
            style: _normalizeStyle(
                        !_ctx.isVisible
                            ? 'border-bottom: 1px solid rgba(228, 234, 240, 1)'
                            : ''
                    ),
            key: index
          }, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  (item.status.id === 1)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_26, [
                        _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.pending" })
                      ]))
                    : _createCommentVNode("", true),
                  (item.status.id === 2)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_27, [
                        _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.successful" })
                      ]))
                    : _createCommentVNode("", true),
                  (item.status.id === 3)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_28, [
                        _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.cancelled" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.isVisible[index])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        width: "16",
                        height: "16",
                        src: "/img/chevron-down.svg",
                        onClick: ($event: any) => (_ctx.visible(index, null))
                      }, null, 8, _hoisted_29))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        width: "16",
                        height: "16",
                        src: "/img/chevron-down%20(1).svg",
                        onClick: ($event: any) => (_ctx.visible(index, item.id))
                      }, null, 8, _hoisted_30))
                ])
              ]),
              (item.reference !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_i18n_t, { keypath: "myOrders.paymentReference" }),
                      _createTextVNode(" : ")
                    ]),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(item.reference), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, [
                  _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.paymentDate" }),
                  _createTextVNode(":")
                ]),
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatDate(item.date)), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, [
                  _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.paymentType" }),
                  _createTextVNode(":")
                ]),
                _createElementVNode("span", _hoisted_39, _toDisplayString(item.type.name), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, [
                  _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.transactionSum" }),
                  _createTextVNode(":")
                ]),
                _createElementVNode("span", _hoisted_42, [
                  _createVNode(_component_app_format_currency, {
                    value: item.total_amount_euro,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("span", _hoisted_45, _toDisplayString(item.id), 1)
              ]),
              (item.status.id === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "button-cancel",
                        onClick: ($event: any) => (_ctx.cancelPayment(item.id))
                      }, [
                        _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.cancel" })
                      ], 8, _hoisted_47)
                    ]),
                    (item.type.id !== 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("button", {
                            class: "button-proceed",
                            onClick: ($event: any) => (_ctx.proceedPayment(item.id))
                          }, [
                            _createVNode(_component_i18n_t, { keypath: "paymentsTransactionsPopup.proceed" })
                          ], 8, _hoisted_49)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderVehiclePaymentLinkDto, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "dropdown-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("img", {
                            width: "90",
                            height: "59",
                            src: item.thumbnail_image.href_small
                          }, null, 8, _hoisted_53)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, _toDisplayString(item.vehicle.brand.name) + " " + _toDisplayString(item.vehicle.model), 1),
                          _createElementVNode("div", _hoisted_56, _toDisplayString(item.vehicle.powertrain.motorisation) + " " + _toDisplayString(item.vehicle.finish), 1),
                          _createElementVNode("div", _hoisted_57, " € " + _toDisplayString(item.payment_amount), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.isVisible[index]]
              ])
            ])
          ], 4))
        }), 128))
      ])
    ])
  ]))
}